import { render, staticRenderFns } from "./MyParkings.vue?vue&type=template&id=152bf872"
import script from "./MyParkings.vue?vue&type=script&lang=js"
export * from "./MyParkings.vue?vue&type=script&lang=js"
import style0 from "./MyParkings.vue?vue&type=style&index=0&id=152bf872&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports